 <div  *ngIf="!initialLoading; else loading" > 
 

        
           <div class="streams-page"  *ngIf="playlist" > 
  <!-- -->
<div class="row">
<div class="col-12">
		<h5 class="mainTitle">{{playlist.title}}</h5>
</div>

</div>

    <div class="row">

			 
        <div class="col-xs-12 col-md-7">
            <nb-card>
                <nb-card-header>
                    Інформація
                </nb-card-header>
                <nb-card-body>
 
		<app-playlist-info #infoComponent [playlist]="playlist"></app-playlist-info>
                </nb-card-body>

            </nb-card>

  				 <nb-card [nbSpinner]="itemsLoading">
					<nb-card-header>
					    Плейлист
					</nb-card-header>
					<nb-card-body>
							<div style="margin-bottom:15px; width:100%"  class="d-flex">
							<div  style="width:calc(100% - 47px); margin-right:15px"  class="d-flex"> 

									<nb-select [(ngModel)]="selectedItem" multiple fullWidth placeholder="...">

									      <nb-option-group title="Трансляції">
								<nb-option *ngFor="let s of selectList?.streams" [value]="s">{{s.title}}</nb-option>
									      </nb-option-group>
 
									      <nb-option-group title="Відео">
							<nb-option *ngFor="let v of selectList?.videos" [value]="v">{{v.title}}</nb-option>
									      </nb-option-group> 

									 </nb-select>

								 </div>
								<div  class="d-flex addItemWrapp">
	 								
							 
								 <button nbButton [disabled]="!selectedItem?.length" size="small" (click)="addItem()" status="primary"> <nb-icon  [icon]="'plus-outline'" pack="eva"></nb-icon></button>
								</div>
							</div>


			 	<!--  -->
						<div class="playlist-list">
					           <nb-list class="scrollable-container" style="max-height:350px;     height: auto;"   [sortablejs]="playlistItems" [sortablejsOptions]="sortablejsOptions">
						 <nb-list-item class="playlist-item" *ngFor="let item of playlistItems; let i = index" [attr.data-index]="i">
							 
 							<div style="width:100%"  class="d-flex">
								<div   class="d-flex sortPlaylistItem"> <nb-icon  class="draggableHandler" style="cursor:grabbing; font-size:15px" [icon]="'keypad-outline'" pack="eva"></nb-icon> </div>
	 								
								<div style=" margin-right:15px;"   class="d-flex"> {{item.title}} </div>
								<div (click)="itemsRemoveHandler($event,item)" class="d-flex removePlaylistItem">
 									<nb-icon  style="cursor:pointer; color:red" [icon]="'close-outline'" pack="eva"></nb-icon>
								</div>
							</div>
							</nb-list-item>
						   </nb-list>
 
						</div>

						 <div  style="margin-top:15px" class="d-flex">
							<div style="margin-left:auto" class="d-flex">
							   <button nbButton status="primary" [disabled]="!itemsUpdated" (click)="onItemsSave()">Зберегти</button>
							</div>
						</div>
						
					</nb-card-body>

				    </nb-card>
	          	


        </div>
        
		<div style="position: relative; z-index: 7;"  class="col-xs-12 col-md-5">



			<div class="rightPanels" >

	 			 <nb-card>
			  
				<nb-card-body>
				<div style="display:flex; align-items:center;">
					<div>Опублікований?</div>

					<div style="display:flex; margin-left:auto">


						   <nb-toggle  
						     labelPosition="left"
						      [(checked)]="publish" 
						      (checkedChange)="togglePublish()" 
						      status="primary">
						      <span *ngIf="publish">Так</span>
						      <span *ngIf="!publish">Ні</span>
						    </nb-toggle>


					</div>
				</div>
				 </nb-card-body>
		 	  	 </nb-card>
			   
				

			<!--   -->


				 <nb-card *ngIf="channelUrl">
					   <nb-card-header>
						 
						<div style="display:flex;  ">
							<div  style=" margin-right:15px ">Плейлист</div>

							<div style="display:flex; margin-left:auto">
				 				<a target="_blank" style="font-weight: normal;"
	 [href]="domain.protocol+domain.name+'/channel/'+channelUrl+'#playlists/'+playlist._id">Перейти</a>
				 
							</div>
						</div>
					   </nb-card-header> 
				   </nb-card> 
		
			

			 <app-playlist-sale-control [playlist]="playlist"></app-playlist-sale-control>
				
			</div>

		</div>
 


	</div>




<div style="min-height:250px;"></div> 
</div>

</div>






 
 
<ng-template #loading>
      <app-skeleton-page  [type]="'playlists'" ></app-skeleton-page>
</ng-template> 

